import React from 'react';

const InputForms = ({ type, data, onChange }) => {
  
  const handleChange = (key, value) => {
    onChange({ ...data, [key]: value });
  };

  const renderForm = () => {
    switch (type) {
      case 'website':
        return (
          <div className="space-y-4">
            <label className="block text-sm font-medium text-slate-300">網站連結 (URL)</label>
            <input
              type="url"
              className="glass-input"
              placeholder="https://example.com"
              value={data.url || ''}
              onChange={(e) => handleChange('url', e.target.value)}
            />
          </div>
        );
      case 'pdf':
        return (
          <div className="space-y-4">
            <label className="block text-sm font-medium text-slate-300">PDF 文件連結</label>
            <input
              type="url"
              className="glass-input"
              placeholder="https://example.com/file.pdf"
              value={data.pdfUrl || ''}
              onChange={(e) => handleChange('pdfUrl', e.target.value)}
            />
            <p className="text-xs text-slate-500">* 請輸入已上傳到雲端的 PDF 檔案連結</p>
          </div>
        );
      case 'contact':
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">姓名</label>
              <input
                type="text"
                className="glass-input"
                placeholder="王小明"
                value={data.name || ''}
                onChange={(e) => handleChange('name', e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">電話</label>
              <input
                type="tel"
                className="glass-input"
                placeholder="0912345678"
                value={data.phone || ''}
                onChange={(e) => handleChange('phone', e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Email</label>
              <input
                type="email"
                className="glass-input"
                placeholder="example@mail.com"
                value={data.email || ''}
                onChange={(e) => handleChange('email', e.target.value)}
              />
            </div>
          </div>
        );
      case 'whatsapp':
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">WhatsApp 號碼</label>
              <input
                type="tel"
                className="glass-input"
                placeholder="886912345678 (不含+號)"
                value={data.waNumber || ''}
                onChange={(e) => handleChange('waNumber', e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">預設訊息</label>
              <textarea
                className="glass-input min-h-[80px]"
                placeholder="你好，我想詢問..."
                value={data.waMessage || ''}
                onChange={(e) => handleChange('waMessage', e.target.value)}
              />
            </div>
          </div>
        );
      case 'phone':
        return (
          <div className="space-y-4">
            <label className="block text-sm font-medium text-slate-300">電話號碼</label>
            <input
              type="tel"
              className="glass-input"
              placeholder="0912345678"
              value={data.tel || ''}
              onChange={(e) => handleChange('tel', e.target.value)}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="animate-fade-in">
      {renderForm()}
    </div>
  );
};

export default InputForms;